import { toast as nativeToast } from 'react-toastify';

export const useNotification = () => {
  return (msg, type) => {
    const toastType = type === 'err' ? 'error' : 'success'
    nativeToast(msg, {
      type: toastType,
    })
  }
}